import * as R from "ramda";

import {
  CourseView,
  ICourseComponent,
  ICourseInstruction,
  ICourseUnit,
  IFullCourse,
} from "../components/course-author/types";
import { composeView, courseComponentViews } from "./courseViews";

export function constructView(
  course: IFullCourse,
  unitPath: ICourseUnit[]
): CourseView<ICourseComponent[], IFullCourse>;
export function constructView(
  course: IFullCourse,
  unitPath: ICourseUnit[],
  component: ICourseUnit
): CourseView<ICourseUnit, IFullCourse>;
export function constructView(
  course: IFullCourse,
  unitPath: ICourseUnit[],
  component: ICourseInstruction
): CourseView<ICourseInstruction, IFullCourse>;
export function constructView(
  course: IFullCourse,
  unitPath: ICourseUnit[],
  component: ICourseComponent
): CourseView<ICourseComponent, IFullCourse>;
export function constructView(course: IFullCourse, unitPath: ICourseUnit[], component?: ICourseComponent) {
  const initialView: CourseView<ICourseComponent[], IFullCourse> = R.pathOr(null, [
    "state",
    "content",
    "value",
    "root",
    "children",
    "elems",
  ]);
  const unitPathView = unitPath.reduce((currentView, unit): CourseView<ICourseComponent[], IFullCourse> => {
    const list = currentView(course) || [];
    const idx = R.indexOf(unit, list);
    return composeView(R.pathOr(null, [idx, "content", "children", "elems"]), currentView);
  }, initialView);

  const finalList = unitPathView(course) || [];

  if (R.isNil(component)) {
    return unitPathView;
  }

  const jdx = R.indexOf(component, finalList);

  return composeView(R.pathOr(null, [jdx]), unitPathView);
}

export function extendView(
  course: IFullCourse,
  view: CourseView<ICourseUnit, IFullCourse> | undefined,
  component: ICourseUnit
): CourseView<ICourseUnit, IFullCourse>;
export function extendView(
  course: IFullCourse,
  view: CourseView<ICourseUnit, IFullCourse> | undefined,
  component: ICourseInstruction
): CourseView<ICourseInstruction, IFullCourse>;
export function extendView(
  course: IFullCourse,
  view: CourseView<ICourseUnit, IFullCourse> | undefined,
  component: ICourseComponent
): CourseView<ICourseComponent, IFullCourse> {
  if (R.isNil(view)) {
    return constructView(course, [], component);
  }

  const childrenView = composeView(courseComponentViews.children, view);

  const idx = R.indexOf(component, childrenView(course) || []);

  return composeView<ICourseComponent, ICourseComponent[], IFullCourse>(
    R.pathOr<ICourseComponent | null>(null, [idx]),
    childrenView
  );
}
